import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-22ea763b"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "pagination-container",
  "aria-label": "row pagination"
}
const _hoisted_2 = {
  key: 0,
  class: "pagination"
}
const _hoisted_3 = ["aria-label", "onClick"]

import { toRefs, computed } from "vue";
import { BtnRightIcon } from "../atoms";


export default /*#__PURE__*/_defineComponent({
  __name: 'MoleculePagination',
  props: {
  numberOfPages: {
    required: true,
  },
  modelValue: {
    required: true,
    type: Number,
  },
},
  emits: ["update:modelValue"],
  setup(__props, { emit }) {

const props = __props;



const { numberOfPages, modelValue: currentPage } = toRefs<any>(props);



const pages = computed(() => {
  let numShown = 6;
  numShown = Math.min(numShown, numberOfPages.value);
  let first = currentPage.value - Math.floor(numShown / 2);
  first = Math.max(first, 1);
  first = Math.min(first, numberOfPages.value - numShown + 1);
  return [...Array(numShown)].map((k, i) => i + first);
});

const setCurrentPage = (number: any) => {
  emit("update:modelValue", number);
};

const previous = () => {
  if (currentPage.value === 1) return;
  emit("update:modelValue", currentPage.value - 1);
};

const next = () => {
  if (currentPage.value >= numberOfPages?.value) return;
  emit("update:modelValue", currentPage.value + 1);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      (_unref(numberOfPages) >= 1)
        ? (_openBlock(), _createElementBlock("ul", _hoisted_2, [
            _createElementVNode("li", {
              class: _normalizeClass(["navigation", {
          disabled: _unref(currentPage) === 1,
        }]),
              "aria-label": "go to previous page",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (previous()))
            }, [
              _createVNode(_unref(BtnRightIcon), { class: "prev" })
            ], 2),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(pages), (index) => {
              return (_openBlock(), _createElementBlock("li", {
                key: index,
                "aria-label": 'go to page ' + index,
                class: "page-item",
                onClick: ($event: any) => (setCurrentPage(index))
              }, [
                _createElementVNode("div", {
                  class: _normalizeClass(["page-link", {
            'active-page': _unref(currentPage) === index,
          }])
                }, _toDisplayString(index), 3)
              ], 8, _hoisted_3))
            }), 128)),
            _createElementVNode("li", {
              class: _normalizeClass(["navigation", {
          disabled: _unref(currentPage) === _unref(numberOfPages) || !_unref(numberOfPages),
        }]),
              "aria-label": "go to next page",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (next()))
            }, [
              _createVNode(_unref(BtnRightIcon))
            ], 2)
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})